export default {
  alloyfactorLimitsLabel: 'Legierungsfaktorgrenzen',
  alloyFactorCFerrite: 'Legierungsfaktor C (Ferrit)',
  alloyFactorCAustenite: 'Legierungsfaktor C (Austenit)',
  alloyFactorNFerrite: 'Legierungsfaktor N (Ferrit)',
  alloyFactorNAustenite: 'Legierungsfaktor N (Austenit)',
  activityCoefficients: 'Aktivitätskoeffizienten',
};
